import { Switch } from '@progress/kendo-react-inputs';
import type { ToggleSwitchProps } from './toggle-switch.types.ts';
import styles from './toggle-switch.module.scss';

export function ToggleSwitch({ checked, size, onChange }: ToggleSwitchProps) {
  return (
    <div className={styles.container}>
      <Switch checked={checked} size={size} thumbRounded={'medium'} trackRounded={'medium'} onChange={onChange} />
    </div>
  );
}
